<template lang="html">
    <div>
        <div class="container container-small">
            <br/>
            <div class="row">
                <div class="col-sm pr-sm-0">
                    <div class="d-flex search-car-number-wrapper">
                        <div class="form-group search-car-number">
                            <input type="text" class="form-control mb-2" v-model="carPlateFilter" @keypress.enter="loadOrders" :placeholder=" $t('search_car_after_license_plate') ">
                        </div>
                        <button class="main-btn" @click="loadOrders()">{{$t('search_car_button')}}</button>
                    </div>
                </div>
                <div class="col-sm pl-sm-0">
                    <div class="form-group mb-2 flex-sm-grow-1">
                        <select class="form-control" v-model="orderStatusFilter" @change="loadOrders()">
                            <option :value="null">{{$t('choose_status')}}</option>
                            <option v-for="status in orderSts" :value="status.stsID">{{ status.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <ul class="nav nav-tabs d-flex" id="myTab" role="tablist">
                <li class="nav-item flex-grow-1 text-center" role="presentation">
                    <a class="nav-link active" id="vignettes-tab" data-toggle="tab" href="#vignettes" role="tab" @click="tab='erv'" aria-controls="vignettes" aria-selected="true">{{ $tc('vignetteWord', 2) }}</a>
                </li>
                <li class="nav-item flex-grow-1 text-center" role="presentation">
                    <a class="nav-link" id="toll-tab" data-toggle="tab" href="#toll" role="tab" aria-controls="toll" @click="tab='toll'" aria-selected="false">{{ $tc('tollWord', 1) }}</a>
                </li>
            </ul>
            <template v-if="device == 'desktop'">
                <div class="row align-items-center mt-4">
                    <div class="col-sm-6 col-12">
                        <button class="main-btn" @click="downloadOrderCsv('erv')" v-if="tab == 'erv'">{{ $t('btn_export_all_orders') }}</button>
                        <button class="main-btn" @click="downloadOrderCsv('tpf')" v-if="tab == 'toll'">{{ $t('btn_export_all_orders') }}</button>
                    </div>
                    <div class="col-sm-6 col-12 text-center">
                        <a class="link" @click.prevent="triggerReportControls()">{{ $t('btn_report_emitted', {'type': tab == 'erv' ? $tc('vignette', 2) : $tc('passing', 2)}) }}</a>
                    </div>
                </div>
                <div class="row mt-0 mt-sm-4" v-if="showRaportControls">
                    <div class="col-sm col-12 mb-sm-0 mb-2">
                        <span v-if="generateReportEmittedCsvAttempt && reportFromDate == null" class="invalid-feedback">
                            {{ $t('mandatory') }}
                        </span>
                        <datepicker class="form-group"
                            id="dp-start"
                            :language="getDatepickerTranslationsObj()"
                            :class="{ 'has-error': generateReportEmittedCsvAttempt && reportFromDate == null }"
                            :disabled-dates="disabledDates" 
                            :bootstrap-styling="true" 
                            :placeholder="$t('start_valability')" 
                            v-model="reportFromDate"
                        >
                        </datepicker>
                    </div>
                    <div class="col-sm col-12 mb-sm-0 mb-2">
                        <span v-if="generateReportEmittedCsvAttempt && reportToDate == null" class="invalid-feedback">
                            {{ $t('mandatory') }}
                        </span>
                        <datepicker class="form-group" 
                            id="dp-end"
                            :language="getDatepickerTranslationsObj()"
                            :class="{ 'has-error': generateReportEmittedCsvAttempt && reportToDate == null }"
                            :disabled-dates="disabledDates" 
                            :bootstrap-styling="true" 
                            :placeholder="$t('end_valability')" 
                            v-model="reportToDate"
                        >
                        </datepicker>
                    </div>
                    <div class="col-sm-4 col-12">
                        <button class="main-btn" @click="generateReportEmittedCsv(tab)">{{ $t('info_download_file') }}</button>
                    </div>
                </div>
            </template>
            <Pagination :page="page_erv" :class="'no-plr'" :total="orders_vignette_total" @goToPage="setPage('erv', $event)" v-if="tab == 'erv'"></Pagination>
            <Pagination :page="page_tpf" :class="'no-plr'" :total="orders_toll_total" @goToPage="setPage('tpf', $event)" v-if="tab == 'toll'"></Pagination>
            <div class="orders-content">
                <div class="tab-content" id="orders">
                    <div class="tab-pane fade show active" id="vignettes" role="tabpanel" aria-labelledby="vignettes-tab">
                        <template v-if="orders_vignette && !loading">
                            <div class="header mt-md-4 top">
                                <div class="header-pill name">
                                    {{$t('order_header_name')}}
                                </div>
                                <div class="header-pill data">
                                    {{$t('date')}}
                                </div>
                                <div class="header-pill payment-type">
                                    {{$t('order_header_payment_type')}}
                                </div>
                                <div class="header-pill status">
                                    {{$t('order_header_status')}}
                                </div>
                                <div class="header-pill total d-sm-block d-none">
                                    {{$t('total')}}
                                </div>
                            </div>
                            <router-link v-for="(item, key) in orders_vignette" v-bind:key="key" class="cart-item mt-sm-3" :to="{name: 'order', params: {id: item.id, type: 'vignette'}}">
                                <div class="header bottom">
                                    <div class="header-pill name">
                                        {{item.orderName}}<br/>
                                        <span class="d-sm-none d-block">{{(item.valueTotal + item.orderTotalLeiSMS).toFixed(2)}} lei</span>
                                        <div v-if="item.mixed_order && item.orderStatus == 1 && !item.mixed_order.is_old" class="d-none d-sm-block">
                                            <a class="main-btn" @click.stop :href="url + item.mixed_order.hash">{{ $t('continue_payment') }}</a>
                                        </div>
                                    </div>
                                    <div class="header-pill data">
                                        {{item.date}}
                                    </div>
                                    <div class="header-pill payment-type">
                                        {{item.payment_type ? item.payment_type.descriere : '-'}}
                                    </div>
                                    <div class="header-pill status">
                                        {{item.status.name}}
                                    </div>
                                    <div class="header-pill total d-sm-block d-none">
                                        {{(item.valueTotal + item.orderTotalLeiSMS).toFixed(2)}} lei
                                    </div>
                                </div>
                            </router-link>
                        </template>

                        <div v-if="!orders_vignette" class="alert alert-info text-center mt-3">
                            {{$t('no_placed_order')}}
                        </div>
                    </div>
                    <div class="tab-pane fade" id="toll" role="tabpanel" aria-labelledby="toll-tab">
                        <template v-if="orders_toll && !loading">
                            <div class="header mt-md-4 top">
                                <div class="header-pill name">
                                    {{$t('order_header_name')}}
                                </div>
                                <div class="header-pill data">
                                    {{$t('date')}}
                                </div>
                                <div class="header-pill payment-type">
                                    {{$t('order_header_payment_type')}}
                                </div>
                                <div class="header-pill status">
                                    {{$t('order_header_status')}}
                                </div>
                                <div class="header-pill total d-sm-block d-none">
                                    {{$t('total')}}
                                </div>
                            </div>
                            <router-link v-for="(item, key) in orders_toll" v-bind:key="key" class="cart-item mt-sm-3" :to="{name: 'order', params: {id: item.id, type: 'toll'}}">
                                <div class="header bottom">
                                    <div class="header-pill name">
                                        {{item.orderName}}<br/>
                                        <span class="d-sm-none d-block">{{(item.valueTotal + item.orderTotalLeiSMS).toFixed(2)}} lei</span>
                                        <div v-if="item.mixed_order && item.orderStatus == 1 && !item.mixed_order.is_old" class="d-none d-sm-block">
                                            <a class="main-btn" @click.stop :href="url + item.mixed_order.hash">{{ $t('continue_payment') }}</a>
                                        </div>
                                    </div>
                                    <div class="header-pill data">
                                        {{item.date}}
                                    </div>
                                    <div class="header-pill payment-type">
                                        {{item.payment_type ? item.payment_type.descriere : '-'}}
                                    </div>
                                    <div class="header-pill status">
                                        {{item.status.name}}
                                    </div>
                                    <div class="header-pill total d-sm-block d-none">
                                        {{(item.valueTotal + item.orderTotalLeiSMS).toFixed(2)}} lei
                                    </div>
                                </div>
                            </router-link>
                        </template>
                        <div v-if="!orders_toll" class="alert alert-info text-center mt-3">
                            {{$t('no_placed_order')}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container container-small mt-5 mt-sm-0">
            <div class="row">
                <div class="col-12 col-sm-6">
                    <router-link :to="{name: 'vignette'}">
                        <button type="submit" class="btn-vignette btn btn-purple w-100">{{ $t('i_want_vignette') }}</button>
                    </router-link>
                </div>

                <div class="col-12 col-sm-6">
                    <router-link :to="{name: 'toll'}">
                        <button type="submit" class="btn-tpf btn btn-purple w-100">{{ $t('i_want_toll') }}</button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import Pagination from '../snippets/Pagination.vue';
    import axios from '../../plugins/axios';
    import Datepicker from 'vuejs-datepicker'
    import { en, de, ro, hu, sr, ru, tr, bg, pl } from 'vuejs-datepicker/dist/locale'

    export default {
        name: 'MyOrders',
        data: function() {
            return {
                en: en,
                de: de,
                ro: ro,
                hu: hu,
                sr: sr,
                ru: ru,
                tr: tr,
                bg: bg,
                pl: pl,
                loading: false,
                carPlateFilter: null,
                url: process.env.VUE_APP_API_URL + '/orders/pay/',
                orderSts: null,
                page_erv: 1,
                page_tpf: 1,
                paginationType: 'erv',
                tab: 'erv',
                device: process.env.VUE_APP_DEVICE,
                reportFromDate: null,
                reportToDate: null,
                disabledDates: {
                    from: new Date(new Date().setDate(new Date().getDate())), // Disable all dates after specific date
                },
                showRaportControls: false,
                generateReportEmittedCsvAttempt: false
            }
        },
        components: {
            Pagination,
            Datepicker
        },
        computed: {
            ...mapState('orders', [
                'orders_vignette',
                'orders_vignette_total',
                'orders_toll',
                'orders_toll_total',
                'status'
            ]),

            ...mapState('language', [
                'locale'
            ]),

            orderStatusFilter: {
                get() {
                    return this.status;
                },
                set(value) {
                    this.saveStatus(value);
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            ...mapActions({
              getOrdersAction: 'orders/getOrders',
              getOrdersStatusAction: 'ordersStatus/getOrdersStatus',
              saveStatus: 'orders/saveStatus'
            }),            

            /**
             * Returns the translations datepicker object according to locale from vuex store
             */
            getDatepickerTranslationsObj() {
                return this[this.locale];
            },

            triggerReportControls() {
                this.showRaportControls = !this.showRaportControls;
            },

            setPage(type, $event) {
                this.paginationType = type;

                if(type == 'erv') {
                    this.page_erv = $event;
                }
                else {
                    this.page_tpf = $event;
                }

                this.loadOrders();
            },

            async init() {
                await this.loadOrders();
                await this.loadStatus();
            },

            async loadOrders() {
                this.loading = true;

                let params = {};

                if(this.carPlateFilter) {
                    params.car_plate_number = this.carPlateFilter;
                }

                if(this.orderStatusFilter) {
                    params.order_status = this.orderStatusFilter;
                }

                if(this.paginationType == 'erv') {
                    params.page_erv = this.page_erv;
                }

                if(this.paginationType == 'tpf') {
                    params.page_tpf = this.page_tpf;
                }

                try {
                    let response = await this.getOrdersAction(params);
                    this.loading = false;
                }
                catch(error) {
                    console.log(error);
                }
            },

            async loadStatus() {
              this.loading = true;

              let params = {};

              try {
                let response = await this.getOrdersStatusAction(params);

                this.orderSts = response.data.orderStatuses;

                this.loading = false;
              }
              catch(error) {
                console.log(error);
              }
            },

            downloadOrderCsv(type) {
                let data = [];
                axios.get('/orders/export/' + type).then(response => {
                    data = response.data.orders;

                    let csv = '';
                    for(let k in data) {
                        csv += data[k].orderName + ',' + data[k].orderSaveTime + ',' + data[k].orderPaymentMethod + ',' + data[k].orderStatus + ',' + data[k].orderTotal;
                        csv += "\n";
                    }

                    let anchor = document.createElement('a');
                    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                    anchor.target = '_blank';
                    anchor.download = 'orders.csv';
                    anchor.click();
                });
            },

            generateReportEmittedCsv(type) {
                this.generateReportEmittedCsvAttempt = true;

                if(!this.reportFromDate || !this.reportToDate) {
                    return false;
                }

                this.generateReportEmittedCsvAttempt = false;

                let data = [];
                axios.post('/orders/exportEmittedProducts/' + type, {startDate: this.reportFromDate, endDate: this.reportToDate}).then(response => {
                    data = response.data.products;

                    if(!data.length) {
                        this.$dialog.alert({
                            'message': this.$t('no_reponse_data', {'type': this.tab == 'erv' ? this.$tc('vignette', 2) : this.$tc('passing', 2)}),
                            'confirmButtonText': this.$t('btn_i_understand')
                        });

                        return false;
                    }

                    let csv = '';
                    if(type == 'erv') {
                        csv = 'Numar inmatriculare,Serie sasiu,Categorie,Serie rovinieta,Data plasare comanda,Inceput valabilitate,Sfarsit valabilitate' + "\n";
                    }
                    else {
                        csv = 'Numar inmatriculare,Serie sasiu,Categorie,Serie peaj,Data plasare comanda,Inceput valabilitate,Sfarsit valabilitate' + "\n";
                    }

                    for(let k in data) {
                        csv += data[k].vehicleNumber + ',' + data[k].chasisNumber + ',' + data[k].category + ',' + data[k].serie + ',' + data[k].orderAt + ',' + data[k].valabilityFrom + ',' + data[k].valabilityTo;
                        csv += "\n";
                    }

                    let anchor = document.createElement('a');
                    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                    anchor.target = '_blank';
                    anchor.download = 'orders.csv';
                    anchor.click();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #59af54;

.orders-content {

    @media only screen and (max-width: 768px) {
        overflow-x: auto;
        margin: 0px -15px;
        border-bottom: 1px solid #DFDFDD;
    }
}

.header {
    display: flex;

    @media only screen and (max-width: 768px) {
        padding: 0px 15px;
    }

    .header-pill {
        white-space: nowrap;
        flex: 1 0 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 20px;

        a {
            font-size: 14px;
            margin-top: 10px;
        }

        @media only screen and (max-width: 768px) {
            padding: 10.5px 0px;

            &:first-child {
                position: absolute;
                background: #FAF9F6;
                width: 160px;
                padding-right: 10px;
                border-bottom: 1px solid #DFDFDD;
                margin-left: -15px;
                padding-left: 15px;
                box-shadow: 0 0 6px rgba(0,0,0,0.75);
                clip-path: inset(0px -15px 0px 0px);
            }

            &:nth-child(2) {
                margin-left: 170px;
            }
        }
    }


    &.top {
        @media only screen and (min-width: 769px) {
            padding: 0px 10px;
        }

        @media only screen and (max-width: 768px) {
            background: #EEEDEC;
            border-top: 1px solid #DFDFDD;
            border-bottom: 1px solid #DFDFDD;
            width: 570px;

            .header-pill  {
                background: #EEEDEC;
            }
        }
    }

    &.bottom {
        @media only screen and (max-width: 768px) {
            height: 64px;
        }
    }

    .name {
        flex-basis: 192px;

        span {
            font-weight: bold;
        }
    }

    .data {
        flex-basis: 96px;
    }

    .payment-type {
        flex-basis: 117px;
    }

    .status {
        flex-basis: 68px;

        @media only screen and (max-width: 768px) {
            flex-basis: 113px;
        }
    }

    .total {
        flex-basis: 75px;
    }
}

.nav-tabs {

    .nav-item {

        &:first-child {
            margin-right: 10px;
        }

        .nav-link {
            text-align: left;
            padding: 7.5px 0px;

            &:hover {
                text-decoration: underline;
                color: #737880;
            }

            &.active {
                background-color: transparent;
                border-color: transparent;
                border-bottom: 6px solid #0F2443;
            }

            &:not(.active):hover {
                border-color: transparent;
            }
        }
    }
}

.cart-item {
    display: block;
    border-color: transparent;
    border-width: 1px;
    border-style: solid;
    border-radius: 5px;
    font-size: 14px;
    white-space:nowrap;
    background: #EEEDEC;

    &:last-child {
        .header {

            .name {
                clip-path: inset(0px -15px -5px 0px);
            }
        }
    }

    @media only screen and (min-width: 769px) {
        padding: 15px 10px;
    }

    @media only screen and (max-width: 768px) {
        background: none;
        border: 0px;
    }

    span {
        font-size: 14px;
        color: $lightgrey;
    }
    .no-bottom-margin {
        margin-bottom: 0px;
    }
}

.btn-vignette {
    font-weight: bold;
    padding: 15px 0px;

    @media only screen and (min-width: 769px) {
        margin-bottom: 144px;
        margin-top: 40px;
    }

    @media only screen and (max-width: 768px) {
        margin-bottom: 30px;
    }
}

.btn-tpf {
    font-weight: bold;
    padding: 15px 0px;

    @media only screen and (min-width: 769px) {
        margin-bottom: 144px;
        margin-top: 40px;
    }

    @media only screen and (max-width: 768px) {
        margin-bottom: 62px;
    }
}

.alert-info {
    background: #EEEDEC;
    border: none;
}

a:link {
    color: black;
    text-decoration: none;
}
a:visited {
    color: black;
    text-decoration: none;
}
a:hover {
    color: black;
    text-decoration: none;
}
a:active {
    color: black;
    text-decoration: none;
}

.search-car-number-wrapper {

    .search-car-number {
        width: 400px;

        input {
            width: 100%;
        }
    }

    .main-btn {
        max-width: 150px;
        margin-left: 20px;
        height: 50px;
        margin-right: 20px;

        @media only screen and (max-width: 768px) {
            margin-right: 0px;
        }
    }
}

</style>
